import { GRAPH_GRAPH_RESULTS } from "./../redux/graph/types";
// import { Alert } from 'react-native';
import { GREEN_PLOOT, RED_PLOOT } from "../styles/colors";
import { ERROR_OCCURED } from "../constants/return_code_constants";
import { inflation as inflationValue } from "../constants/index";
import { strategyOptions } from "../constants/index";
// Used to add some other functionality to a function if error occurs
export const errorCheck = (code) => code === ERROR_OCCURED;
export const isKhaliCheck = (value) => value === "" || value === null || value === undefined;
export const isNull = (value) => value === null;
// Get random color
export const getRandomColor = () => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i += 1) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
};
// Get color for the Accord item value amount
export const getColorFromType = (type) => type === "INCOME" ? GREEN_PLOOT : RED_PLOOT;
// resolves string path from object (obj.a.b.c : path = 'a.b.c')
export function resolveObjectPath(path, obj) {
    return path
        ? path.split(".").reduce((prev, curr) => (prev ? prev[curr] : null), obj)
        : obj;
}
// Get key array
export const getKeyArray = (objectArray, key) => objectArray.map((item) => item[key]);
export const calculateRetirementAssessts = (retireAge, current_age, openingBalance, contribution, strategyIndex, dispatch) => {
    const assetsGraph = [];
    const earnYears = retireAge - current_age;
    let total = Number(openingBalance) || 0;
    const contributionVal = Number(contribution) || 0;
    const strategyVal = strategyOptions[strategyIndex]?.value || 0;
    // assetsGraph.push({ x: current_age, y: total });
    for (let i = 0; i <= earnYears - 1; i += 1) {
        total += contributionVal;
        total *= 1 + strategyVal;
        assetsGraph.push({ x: i + current_age, y: total });
    }
    dispatch({
        type: GRAPH_GRAPH_RESULTS,
        payload: {
            graph: { assets: assetsGraph },
            results: { retirementAssests: total },
        },
    });
    return total;
};
// Retirment Returns graph
// Todo: format
export const calculateAfterRetirementReturns = ({ lifeExp, retireAge, retirementAssests, strategyIndex, expense_home, socialSecurity, inflation, dispatch, }) => {
    const retirementYears = lifeExp - retireAge;
    const retirementAssets = Number(retirementAssests) || 0;
    let remainingAssets = retirementAssets;
    let totalReturn = 0;
    let totalExpenses = 0;
    const gap = [];
    const future = [];
    const index = +strategyIndex ? +strategyIndex - 1 : 0;
    let flag = false;
    const findSocialSecurity = (age) => {
        let item = socialSecurity?.find((i) => i.Age === age);
        return item ? item.Benefits : 0;
    };
    console.log("Retire Age in Gap : ", retireAge, "+++++++==");
    for (let i = 0; i <= retirementYears - 1; i += 1) {
        const x = i + retireAge;
        const benefit = findSocialSecurity(x);
        let expense = (Number(expense_home) || 0) * Math.pow(inflation, i);
        expense -= benefit;
        future.push({ x, y: expense });
        totalExpenses += expense;
        if (expense >= remainingAssets) {
            gap.push({ x: i + retireAge, y: 0 });
            remainingAssets = 0;
            flag = true;
        }
        else {
            remainingAssets -= expense;
            const retirementReturn = remainingAssets * strategyOptions[index].value;
            remainingAssets += retirementReturn;
            totalReturn += retirementReturn;
            gap.push({ x, y: remainingAssets });
        }
    }
    dispatch({
        type: GRAPH_GRAPH_RESULTS,
        payload: { graph: { gap, future, flag } },
    });
    return { totalReturn, totalExpenses };
};
// Retirment gap calculations
// Todo: format
export const calculateRetirementGap = ({ retireAge, lifeExp, strategyIndex, expense_home, retirementAssests, socialSecurity, inflation = inflationValue, dispatch, }) => {
    const { totalReturn, totalExpenses } = calculateAfterRetirementReturns({
        lifeExp,
        retireAge,
        retirementAssests,
        strategyIndex,
        expense_home,
        socialSecurity,
        inflation,
        dispatch,
    });
    const retirementGap = retirementAssests + totalReturn - totalExpenses;
    dispatch({
        type: GRAPH_GRAPH_RESULTS,
        payload: {
            results: {
                futureExpenses: totalExpenses,
                retireReturns: totalReturn,
                retirementGap,
            },
        },
    });
    return retirementGap;
};
